import { Filters, maskFilterApi } from '../filtering';


export const documentsFilters = {
    type: <Filters.MaskFilterWithApply>{
        dict: 'documentTypes',
        api: maskFilterApi('documentTypeMask'),
        applyFilter: (value, { DocumentTypeCode }) =>
            value.includes(DocumentTypeCode),
    },
    processTemplate: <Filters.MaskFilterWithApply>{
        dict: 'processTemplates',
        api: maskFilterApi('processTemplateMask'),
        applyFilter: (value, { ProcessTemplateCode }) =>
            value.includes(ProcessTemplateCode),
    },
};
